const ClockIcon = ({ className, ...props }) => (
    <svg
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
            stroke="#899CBD"
            strokeWidth="1.5"
        />
        <path
            d="M12 8.42773V12.1479C12 12.4181 12.1094 12.6768 12.3032 12.8651L14.5 14.9991"
            stroke="#899CBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ClockIcon
